export const dynamicDisplayRedirect = (returnUrl?: string | null, showResultScreen?: boolean) => {
  if (returnUrl) {
    return showResultScreen ? 'block' : 'none'
  }

  return 'none'
}
